import { useTranslation } from 'react-i18next';

import { Content, Item, Name, Value } from './list.styled';
import { ToClip } from '../to-clip/to-clip';

export const List = (props) => {
  const { items } = props;
  const { t } = useTranslation();

  const getItemsEl = () => {
    return items.map((el, idx) => {
      const out = el.cmp ? (
        el.cmp
      ) : (
        <>
          <Name>{el.name}:</Name>
          <Value>
            {el.value}
            {el.withCopy && <ToClip title={t('messages.Скопировать в буфер обмена')} value={el.value} />}
          </Value>
        </>
      );
      return <Item key={idx}>{out}</Item>;
    });
  };
  const itemsEl = getItemsEl();
  return <Content>{itemsEl}</Content>;
};
